
import React, { useState } from 'react'

const UserModify = () => {
    const [show, setShow] = useState(false);

    return (
        <>
            <section className='px-5 w-full pt-8 min-h-[25rem]'>
                <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 mb-10 '>
                    <div>
                        <div className="">
                            <label className="block text-sm font-bold mb-2" >First Name<span className='text-red-500'>&#42;</span></label>
                            <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide First Name' />
                        </div>
                    </div>

                    <div>
                        <div className="">
                            <label className="block  text-sm font-bold mb-2">Last Name</label>
                            <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Last Name' />
                        </div>
                    </div>

                    <div>
                        <div className="">
                            <label className="block  text-sm font-bold mb-2" >Email<span className='text-red-500'>&#42;</span></label>

                            <div className='form_div'>
                                <input type="text" className='form_input_icon' placeholder='Please provide Email' />
                                <p className='form_icon_para'>
                                    <i className="fa-regular fa-envelope"></i>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="">
                            <label className="block  text-sm font-bold mb-2" >Role<span className='text-red-500'>&#42;</span></label>
                            <select className="selector">
                                <option selected>Select Role</option>
                                <option value="admin" >GYM Admin</option>
                                <option value="member">GYM Member</option>

                            </select>
                        </div>
                    </div>

                    <div>
                        <div className="">
                            <label className="block  text-sm font-bold mb-2 " >Membership<span className='text-red-500'>&#42;</span></label>
                            <select className="selector">
                                <option selected>Select Membership </option>
                                <option value="Startup" >Startup (fee:-0)</option>
                                <option value="others">Others</option>

                            </select>
                            <p className="font-semibold text-xs">Current Membership will be expried on 2022-03-15</p>
                        </div>
                    </div>

                    <div>
                        <div className="">
                            <label className="block  text-sm font-bold mb-2">Status<span className='text-red-500'>&#42;</span></label>
                            <select className="selector">
                                <option selected>Select Status</option>
                                <option value="Active" >Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="mb-4">
                    <button className="bg-blue-500 hover:bg-blue-600 text-white text-sm font-bold py-2 px-4 rounded-sm" onClick={() => setShow(!show)} type="submit">
                        Change Password
                    </button>
                </div>

                <div className='grid gap-4 md:grid-cols-2 lg:gap-6 mb-10'>
                    {
                        show ?
                            <div>
                                <div className="">
                                    <label className="block  text-sm font-bold mb-2 " >Password<span className='text-red-500'>&#42;</span></label>
                                    <div className='form_div'>
                                        <input type="password" className='form_input flex-[9] h-full border-r-2 pr-4' placeholder='Please provide Password' />
                                        <p className='form_icon_para'>
                                            <i class="fa-solid fa-lock"></i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            : null
                    }

                    <div>
                        <div className="">
                            <label className="block  text-sm font-bold mb-2  ">Payment Remarks<span className='text-red-500'>&#42;</span></label>
                            <textarea className='pl-4 text-gray-800 text-sm h-16  w-full outline-none border-2' placeholder='Remarks...'></textarea>
                        </div>
                    </div>
                </div>

                <div className='my-5 px-4'>
                    <h1 className="text-xl underline ">SMS Setting</h1>
                </div>


                <div className='grid gap-4 md:grid-cols-2 lg:gap-6 mb-10 '>

                    <div className="">
                        <label className="block  text-sm font-bold mb-2" >SMS Username</label>
                        <input type="text" className='form_input border-2 h-10 w-full  placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide username' />
                    </div>

                    <div className="">
                        <label className="block  text-sm font-bold mb-2" >Sms Token</label>
                        <input type="text" className='form_input border-2 h-10 w-full  placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide token' />
                    </div>

                    <div className="">
                        <label className="block  text-sm font-bold mb-2" >SMS Sender Id</label>
                        <input type="number" className='form_input border-2 h-10 w-full  placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide senderid' />
                    </div>

                    <div className="">
                        <label className="block  text-sm font-bold mb-2" >SMS Active/Inactive Status</label>
                        <select className="selector">
                            <option selected>Select Status</option>
                            <option value="Active" >Active</option>
                            <option value="Inactive">Inactive</option>

                        </select>
                    </div>

                </div>

                <div className="flex gap-1 ">

                    <div className="mb-4">
                        <button className="bg-green-600 hover:bg-green-700 text-white text-sm font-bold py-2 px-4 rounded-sm" type="submit">
                            Update
                        </button>
                    </div>

                    <div className="mb-4">
                        <button className="bg-red-600 hover:bg-red-700 text-white text-sm font-bold py-2 px-4 rounded-sm" type="submit">
                            Reset
                        </button>
                    </div>
                </div>

            </section>
        </>
    )
}

export default UserModify
